module.exports = __webpack_public_path__ + "img/margarida.31d665f6.jpg";